import React from 'react';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {createStackNavigator, StackHeaderProps} from '@react-navigation/stack';
import {ThemeProvider} from '@rneui/themed';

import BrandHeader from '../components/BrandHeader';
import {AppRoute} from '../models/AppRoute';
import {
  HeaderConfig,
  RootRewardsFlowParamList,
} from '../models/navigationTypes';
import RewardsActivateTermsAndConditionsScreen from '../screens/rewards/activate/RewardsActivateTermsAndConditionsScreen';
import RewardsActivateVerificationScreen from '../screens/rewards/activate/RewardsActivateVerificationScreen';
import RewardsFullSignUpScreen from '../screens/rewards/RewardsFullSignUpScreen';
import RewardsFullSuccessScreen from '../screens/rewards/RewardsFullSuccessScreen';
import RewardsSignInScreen from '../screens/rewards/RewardsSignInScreen';
import RewardsVerificationScreen from '../screens/rewards/RewardsVerificationScreen';
import RewardsWelcomeBackScreen from '../screens/rewards/RewardsWelcomeBackScreen';
import RewardsSignUp from '../screens/rewards/SignUp';
import RewardsSuccess from '../screens/rewards/Success';
import RewardsTermsAndConditions from '../screens/rewards/TermsAndConditions';
import rewardsTheme from '../theme/rewardsTheme';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

export const header =
  (config: HeaderConfig) =>
  ({navigation, route}: StackHeaderProps) =>
    (
      <BrandHeader
        navigation={navigation as any}
        route={route}
        config={config}
      />
    );

const Stack = createStackNavigator<RootRewardsFlowParamList>();

const RootRewardsFlowStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <ThemeProvider theme={rewardsTheme}>
      <GestureHandlerRootView
        style={{flex: 1}}
        testID="gesture-handler-root-view">
        <Stack.Navigator screenOptions={commonScreenOptions}>
          <Stack.Screen
            name={AppRoute.REWARDS_SIGN_IN}
            component={RewardsSignInScreen}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_WELCOME_BACK}
            component={RewardsWelcomeBackScreen}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_SIGN_UP}
            component={RewardsSignUp}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_VERIFICATION}
            component={RewardsVerificationScreen}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_SUCCESS}
            component={RewardsSuccess}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_TERMS_AND_CONDITIONS}
            component={RewardsTermsAndConditions}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_FULL_SIGN_UP}
            component={RewardsFullSignUpScreen}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_FULL_SUCCESS}
            component={RewardsFullSuccessScreen}
            options={{
              header: header({
                back: false,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />

          {/**
           * Rewards Activate flow
           */}
          <Stack.Screen
            name={AppRoute.REWARDS_ACTIVATE_TERMS_AND_CONDITIONS}
            component={RewardsActivateTermsAndConditionsScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_ACTIVATE_VERIFICATION}
            component={RewardsActivateVerificationScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.REWARDS_ACTIVATE_SUCCESS}
            component={RewardsSuccess}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
              }),
            }}
          />
        </Stack.Navigator>
      </GestureHandlerRootView>
    </ThemeProvider>
  );
};

export default RootRewardsFlowStackNavigator;
